export enum EdlItemPacketStatus {
    DRAFT = 0,
    PUBLISHED = 1,
    ARCHIVED = 2,
    DELETED = 3
}